'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _someInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/some');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var lodash = require('lodash');
require('../utils/index.js');
require('../user/index.js');
var compareVersions = require('compare-versions');
var user_model = require('../user/user.model.js');
var constants = require('../utils/constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _someInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_someInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);

var hasAllWriteQueriesPermssions = function hasAllWriteQueriesPermssions(user, graphName) {
  var _context;
  // 1. super user can access all queries
  if (user.isSuperUser()) {
    return true;
  }

  // 2. FOR Roles
  // 2.1 graph admin can visit graph related queries(roles[graphName] has admin or designer)
  if (_someInstanceProperty__default["default"](_context = ['admin', 'designer']).call(_context, function (p) {
    var _context2;
    return _includesInstanceProperty__default["default"](_context2 = user.getRolesForGraph(graphName)).call(_context2, p);
  })) {
    return true;
  }
  return false;
};
var hasPrivilegesToQuery = function hasPrivilegesToQuery(user, graphName, queryName, privileges) {
  var _queryPermissions$que;
  if (hasAllWriteQueriesPermssions(user, graphName)) {
    return true;
  }
  if (privileges.length <= 0 || !queryName) {
    return false;
  }

  // 3.3 privileges query level
  var queryPermissions = user.getChildPermissionsForGraph(graphName);
  var res = lodash.intersection((_queryPermissions$que = queryPermissions[queryName]) === null || _queryPermissions$que === void 0 ? void 0 : _queryPermissions$que.privileges, privileges);
  return res.length > 0;
};
var canEditQuery = function canEditQuery(userInfo, graphName, queryName, tgVersion) {
  var user = new user_model.User(userInfo);
  // cloud-portal workspace will return tg_version like `4.1.0-123456`.
  // In the context of SemVer, a pre-release version like 4.1.0-123456 has lower precedence than the associated normal version
  if (compareVersions.compare(tgVersion, '4.0.x', '>')) {
    return hasPrivilegesToQuery(user, graphName, queryName, [constants.GSQLPrivilege.Owner, constants.GSQLPrivilege.UpdateQuery]);
  } else {
    return user.hasPrivilege(constants.GSQLPrivilege.WriteQuery, graphName);
  }
};
var canInstallQuery = function canInstallQuery(userInfo, graphName, queryName, tgVersion) {
  var user = new user_model.User(userInfo);
  // cloud-portal workspace will return tg_version like `4.1.0-123456`.
  // In the context of SemVer, a pre-release version like 4.1.0-123456 has lower precedence than the associated normal version
  if (compareVersions.compare(tgVersion, '4.0.x', '>')) {
    return hasPrivilegesToQuery(user, graphName, queryName, [constants.GSQLPrivilege.Owner, constants.GSQLPrivilege.InstallQuery]);
  } else {
    return user.hasPrivilege(constants.GSQLPrivilege.WriteQuery, graphName);
  }
};
var canDropQuery = function canDropQuery(userInfo, graphName, queryName, tgVersion) {
  var user = new user_model.User(userInfo);
  // cloud-portal workspace will return tg_version like `4.1.0-123456`.
  // In the context of SemVer, a pre-release version like 4.1.0-123456 has lower precedence than the associated normal version
  if (compareVersions.compare(tgVersion, '4.0.x', '>')) {
    return hasPrivilegesToQuery(user, graphName, queryName, [constants.GSQLPrivilege.Owner, constants.GSQLPrivilege.DropQuery]);
  } else {
    return user.hasPrivilege(constants.GSQLPrivilege.WriteQuery, graphName);
  }
};
var canRunQuery = function canRunQuery(userInfo, graphName, queryName, tgVersion) {
  var user = new user_model.User(userInfo);
  // cloud-portal workspace will return tg_version like `4.1.0-123456`.
  // In the context of SemVer, a pre-release version like 4.1.0-123456 has lower precedence than the associated normal version
  if (compareVersions.compare(tgVersion, '4.0.x', '>')) {
    return hasPrivilegesToQuery(user, graphName, queryName, [constants.GSQLPrivilege.Owner, constants.GSQLPrivilege.ExecuteQuery]);
  } else {
    return user.hasPrivilege(constants.GSQLPrivilege.WriteQuery, graphName);
  }
};
var canCreateQuery = function canCreateQuery(userInfo, graphName, tgVersion) {
  var user = new user_model.User(userInfo);
  // cloud-portal workspace will return tg_version like `4.1.0-123456`.
  // In the context of SemVer, a pre-release version like 4.1.0-123456 has lower precedence than the associated normal version
  if (compareVersions.compare(tgVersion, '4.0.x', '>')) {
    if (hasAllWriteQueriesPermssions(user, graphName) || user.hasPrivilege(constants.GSQLPrivilege.CreateQuery, graphName)) {
      return true;
    }
    return false;
  } else {
    return user.hasPrivilege(constants.GSQLPrivilege.WriteQuery, graphName);
  }
};
var canReadQuery = function canReadQuery(userInfo, graphName, queryName, tgVersion) {
  var user = new user_model.User(userInfo);
  // cloud-portal workspace will return tg_version like `4.1.0-123456`.
  // In the context of SemVer, a pre-release version like 4.1.0-123456 has lower precedence than the associated normal version
  if (compareVersions.compare(tgVersion, '4.0.x', '>')) {
    return hasPrivilegesToQuery(user, graphName, queryName, [constants.GSQLPrivilege.Owner, constants.GSQLPrivilege.ReadQuery]);
  } else {
    return user.hasPrivilege(constants.GSQLPrivilege.WriteQuery, graphName);
  }
};

exports.canCreateQuery = canCreateQuery;
exports.canDropQuery = canDropQuery;
exports.canEditQuery = canEditQuery;
exports.canInstallQuery = canInstallQuery;
exports.canReadQuery = canReadQuery;
exports.canRunQuery = canRunQuery;
